// components/tracking/SearchForm.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaSearch } from 'react-icons/fa';

const SearchForm = ({ awb, setAwb, onSearch, isSearching, onKeyPress }) => {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 }
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="flex-1 flex items-center justify-center px-4 pt-20 pb-28"
    >
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <FaSearch className="mx-auto text-blue-600 text-4xl mb-4" />
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
            Track Your Shipment
          </h1>
          <p className="text-gray-600 text-lg">
            Enter your AWB number to get real-time tracking updates
          </p>
        </div>
        
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="flex gap-2">
            <div className="flex-1 relative">
              <input
                type="text"
                value={awb}
                onChange={(e) => setAwb(e.target.value.toUpperCase())}
                onKeyPress={onKeyPress}
                placeholder="Enter AWB number (e.g., WV123456789)"
                className="w-full px-4 py-3 rounded-l-lg border-2 border-gray-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                disabled={isSearching}
              />
              {awb && (
                <button
                  onClick={() => setAwb('')}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  type="button"
                >
                  ×
                </button>
              )}
            </div>
            <button
              onClick={onSearch}
              disabled={!awb.trim() || isSearching}
              className="px-8 py-3 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-semibold"
            >
              {isSearching ? 'Tracking...' : 'Track'}
            </button>
          </div>
          
          <div className="mt-4 text-sm text-gray-500 text-center">
            <p>Need help? Contact our support team for assistance.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SearchForm;

// ============================================================================